<template>
  <div>
    <label class="story-city-input-label d-flex align-center">
      <img
        class="story-city-label-icon"
        :src="require('@/assets/icons/description.svg')"
        alt=""
      />
      <div>{{ $t("story.description") }}</div>
    </label>
    <v-hover>
      <template v-slot:default="{ hover }">
        <v-card class="description-container-card" flat outlined>
          <div class="description-container">
            <div
              v-html="getText"
              class="description-container__description"
              id="descriptionTextArea"
            />
          </div>
          <v-fade-transition>
            <v-overlay v-if="hover" absolute color="rgba(253, 253, 253, 0.99)">
              <v-btn
                class="edit-content-button rounded-xl px-6 py-2"
                @click="toggleDialog(true)"
                color="primaryLight"
                elevation="0"
              >
                <v-icon size="18" class="mr-2" color="textOnPrimary">$pencil</v-icon>
                {{ $t("story.editDescription") }}
              </v-btn>
            </v-overlay>
          </v-fade-transition>
        </v-card>
      </template>
    </v-hover>
    <v-text-field
      v-show="false"
      v-model="getText"
      height="0"
      style="font-size: 0px; padding: 0"
    />
    <EditDescriptionDialog v-model="dialog" />
  </div>
</template>

<script>
import EditDescriptionDialog from "@/components/CreatorTools/StoryHub/BasicInfo/EditDescriptionDialog";
import hasDialog from "@/mixins/hasDialog";
import { mapGetters } from "vuex";
export default {
  mixins: [hasDialog],
  computed: {
    ...mapGetters("sharedStoryDescription", ["getText"]),
  },
  components: {
    EditDescriptionDialog,
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-text-field > .v-input__control > .v-input__slot:before {
  border-color: transparent !important;
  border-image: none;
}

.v-card.description-container-card {
  border: 1px solid var(--v-lightBackground-base);
  border-radius: 10px;
}
</style>
